import { attachToDebug } from '@/util/debug';

export function getBuild() {
  return {
    id: import.meta.env.VITE_BUILD_ID || 'DEV',
    number: import.meta.env.VITE_BUILD_NUMBER || 'DEV',
    gitCommitHash: import.meta.env.VITE_BUILD_GIT_COMMIT_HASH || 'DEV',
  };
}

attachToDebug('build', getBuild());
